import React from "react";
import classnames from "classnames";

import "../../assets/styles/templates/Template3.scss";
import phone from "../../assets/img/phone-black.png";
import envelope from "../../assets/img/envelope-black.png";
import pin from "../../assets/img/pin-black.png";

import { TemplateProps } from "../../types";

export interface Template3State {}

export const Template3 = React.forwardRef<HTMLDivElement, TemplateProps>(
  (props, ref) => {
    const {
      userImage,
      activeLanguages,
      activeSkills,
      store,
      activeExperience,
      activeCourses,
    } = props;
    const { personalData, about, workExperience, reward, education } = store;
    return (
      <div id="a4" ref={ref}>
        <div id="t3" className={`template palette-${store.palette + 1}`}>
          <div className="my-row">
            <div className="left-margin"></div>
            <div id="about">
              <div className="personal">
                <div className="info">
                  {userImage ? (
                    <div className="user">
                      <img src={userImage} alt="user" />
                    </div>
                  ) : (
                    <div className="user"></div>
                  )}
                  <div className="border"></div>
                  <div className="section">
                    <div className="contact">
                      <img
                        src={phone}
                        alt="phone"
                        className="icon phone-icon"
                      />
                      <span>{personalData.phone}</span>
                    </div>
                    <div className="contact">
                      <img
                        src={envelope}
                        alt="envelope"
                        className="icon envelope-icon"
                      />
                      <span>{personalData.email}</span>
                    </div>
                    <div className="contact last">
                      <img src={pin} alt="pin" className="icon pin-icon" />
                      <div>
                        <span>{personalData.street}</span>
                        <span>
                          {personalData.postal}
                          {personalData.postal.length > 0 ? ", " : ""}
                          {personalData.city}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="skills">
                {activeLanguages.length > 0 && (
                  <>
                    <div className="border"></div>
                    <div className="section">
                      <div className="section-heading border-pseudo-primary">
                        JĘZYKI
                      </div>
                      {activeLanguages.map((language, index) => (
                        <div
                          className="section-element"
                          key={`${language.name}${index}`}
                        >
                          <span>{language.name}</span>
                          <div className="dots">
                            {new Array(5)
                              .fill("")
                              .map((_i: string, dot: number) => (
                                <span
                                  key={dot}
                                  className={classnames("dot", {
                                    active: dot + 1 <= language.value,
                                  })}
                                ></span>
                              ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
                {activeSkills.length > 0 && (
                  <>
                    <div className="border"></div>
                    <div className="section">
                      <div className="section-heading">UMIEJĘTNOŚCI</div>
                      {activeSkills.map((skill, index) => (
                        <div
                          className="section-element"
                          key={`${skill.name}${index}`}
                        >
                          <span>{skill.name}</span>
                        </div>
                      ))}
                    </div>
                    <div className="border"></div>
                  </>
                )}
              </div>
            </div>
            <div id="content">
              <div className="about">
                <div className="cv-title">CURRICULUM VITAE</div>
                <div className="name">
                  <span className="full-name">
                    {personalData.name.length > 0 && (
                      <>
                        <span className="name-bigger">
                          {personalData.name[0].toUpperCase()}
                        </span>
                        <span>{personalData.name.slice(1).toUpperCase()}</span>
                      </>
                    )}
                    {personalData.lastName.length > 0 && (
                      <>
                        &nbsp;
                        <span className="name-bigger">
                          {personalData.lastName[0].toUpperCase()}
                        </span>
                        <span>
                          {personalData.lastName.slice(1).toUpperCase()}
                        </span>
                      </>
                    )}
                  </span>
                </div>
                <div className="border"></div>
                <div className="title">O MNIE</div>
                <div className="border"></div>
                <div className="section about-me">
                  <div className="section-element">
                    <span>{about}</span>
                  </div>
                </div>
                <div className="border"></div>
                {(workExperience.length > 0 ||
                  reward.length > 0 ||
                  activeExperience.length > 0) && (
                  <>
                    <div className="section content-section">
                      <div className="section-heading content-heading">
                        DOŚWIADCZENIE
                      </div>
                      <div className="with-border">
                        {workExperience.map((experience, index) => (
                          <div
                            className="work-experience"
                            key={`${experience.company}${index}`}
                          >
                            <div className="date-wrapper border-after-primary">
                              <div className="date bg-primary ">
                                <span>
                                  {experience.dateStart} - {experience.dateEnd}
                                </span>
                              </div>
                            </div>
                            <div className="details">
                              <div className="experience-heading">
                                {experience.role.toUpperCase()}
                              </div>
                              {experience.description.length > 0 && (
                                <span>{experience.description}</span>
                              )}
                              {experience.company.length > 0 && (
                                <span>{experience.company}</span>
                              )}
                            </div>
                          </div>
                        ))}
                        {reward.map((reward, index) => (
                          <div
                            className="work-experience"
                            key={`${reward.company}${index}`}
                          >
                            <div className="date-wrapper border-after-primary">
                              <div className="date bg-primary ">
                                {reward.date}
                              </div>
                            </div>
                            <div className="details background-pseudo-primary">
                              <div className="experience-heading">
                                {reward.name.toUpperCase()}
                              </div>
                              {reward.description.length > 0 && (
                                <span>{reward.description}</span>
                              )}
                              {reward.company.length > 0 && (
                                <span>{reward.company}</span>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="single-experience-wrapper">
                        {activeExperience.map((experience, index) => (
                          <div
                            className="work-experience single-experience"
                            key={`${experience.name}${index}`}
                          >
                            <div className="details background-pseudo-primary">
                              <div className="experience-heading">
                                {experience.name.toUpperCase()}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="border"></div>
                  </>
                )}
                {education.length > 0 && (
                  <>
                    <div className="section education">
                      <div className="section-heading border-pseudo-primary">
                        EDUKACJA
                      </div>
                      <div className="with-border">
                        {education.map((education, index) => (
                          <div
                            className="work-experience"
                            key={`${education.name}${index}`}
                          >
                            <div className="date-wrapper border-after-primary">
                              <div className="date bg-primary ">
                                {education.year}
                              </div>
                            </div>
                            <div className="details background-pseudo-primary">
                              <div className="experience-heading">
                                {education.name.toUpperCase()}{" "}
                                {education.address.length > 0 && (
                                  <> | {education.address.toUpperCase()}</>
                                )}
                              </div>
                              {education.profile.length > 0 && (
                                <span>{education.profile}</span>
                              )}
                              {education.title.length > 0 && (
                                <span>{education.title}</span>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="border"></div>
                  </>
                )}
                {activeCourses.length > 0 && (
                  <>
                    <div className="section courses">
                      <div className="section-heading border-pseudo-primary">
                        KURSY / CERTYFIKATY
                      </div>
                      <div className="my-row wrap">
                        {activeCourses.map((course, index) => (
                          <div
                            className="work-experience single-experience"
                            key={`${course.name}${index}`}
                          >
                            <div className="details">
                              <div className="experience-heading">
                                {course.name.toUpperCase()}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default Template3;
